import "./app.scss";

import { AppProps, State } from "./types";
import React, { lazy } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { getLoggedInUser } from "./redux/domain/auth";
import { Dispatch } from "redux";
import TagManager from 'react-gtm-module'

const App = ({
  isAppLoading,
  isLicenseLoading,
  onGetLoggedInUser,
}: AppProps) => {

  React.useEffect(() => {
    onGetLoggedInUser();
  // eslint-disable-next-line
  }, [])

  // React GTM
  const tagManagerArgs = {
    gtmId: "GTM-WRMZ3BM",
  }
  if (localStorage.getItem("isGoogleAnalyticsEnabled") !== "false") {
    TagManager.initialize(tagManagerArgs)
  }

  const AppHeaderComponent = lazy(() => import('./components/common/header/header'));
  const AppRoutesComponent = lazy(() => import('./appRoutes'));
  const AppFooterComponent = lazy(() => import('./components/common/footer/footer'));

  return (
      <div className="app-body">
        <AppHeaderComponent />
        <div className="app-wrapper">
          <AppRoutesComponent />
        </div>
        <AppFooterComponent />
      </div>
  );
};

const mapStateToProps = ({ ui }: State) => ({
  isAppLoading: ui.app.isAppLoading,
  isLicenseLoading: ui.app.isLicenseLoading,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onGetLoggedInUser: () => dispatch(getLoggedInUser())
});

export default withRouter<any, any>(
  connect(mapStateToProps, mapDispatchToProps)(App)
);